import styled from "styled-components";
import { Drawer as AntdDrawer } from "antd";

interface Device {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  [index: string]: string;
}

const DEVICE: Device = {
  sm: "(max-width: 480px)",
  md: "(max-width: 768px)",
  lg: "(max-width: 992px)",
  xl: "(max-width: 1200p)x",
};

export const Drawer = styled(AntdDrawer)`
  .ant-drawer-content-wrapper {
    width: 500px !important;
  }
  .ant-drawer-body {
    padding: 0 0;
  }
  .ant-drawer-title {
    font-size: 24px;
    font-weight: 600;
  }

  @media ${DEVICE.sm} {
    .ant-drawer-content-wrapper {
      width: 100vw !important;
    }
  }
`;
